import { Component, EventEmitter, Injector, OnInit, Output } from "@angular/core";
import { ManageLineService } from "src/app/services/manage-line.service";
import { UtilsService } from "src/app/services/utils.service";
import { HttpCacheService } from "src/app/services/http-cache.service";
import {  COMMON_CONSTANTS, MANAGE_LINE_CONST, TRANSACTION_HISTORY_CONSTANTS  } from '../../../common/core/common.constants';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { Router } from "@angular/router";

@Component({
  selector: "app-tpop-change",
  templateUrl: "./tpop.component.html",
  styleUrls: ["./tpop.component.scss"],
})

export class TpopComponent implements OnInit {
  authoringContentData;
  ngbModalOptions;
  portOutPin=0;
  tpcStatus = false;
  popupTitle = "";
  popupMessage = "";
  GEN_POP : any;
  selectedActivity;
  resData : any  ;
  tpopContentSuccessNote1 = "";
  tpopContentSuccessNote2 = "";
  tpopContentMultiSuccessGen1 = ""; 
  tpopContentMultiSuccessGen2 = "";  
  selectedLines = [];
  reqLIne = [];
  isMultiline = false;
  activeLine = 0;
  _helperUtilSvc: HelperUtilityService;
  transactionAction = "";
  transactionRef = "";
  deactivated = false;
  router: Router;
  @Output() closeInfo: EventEmitter<any> = new EventEmitter();
  constructor(
    public manageLineService: ManageLineService,
    public utilsSvc: UtilsService,
    public _cacheSvc: HttpCacheService,
    private injector : Injector
  ) {
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.router = this.injector.get<Router>(Router);
  }

  ngOnInit() {
    if(this.selectedLines?.length>1)this.isMultiline = true;
    this.selectedLines?.forEach((node) => {
      node['isSelected'] = true;
    });
    this.authoringContentData = this.utilsSvc.getContentDataFromSession().tpop;
    this.popupTitle = this.authoringContentData?.tpopTitle;
    this.popupMessage = this.isMultiline?this.authoringContentData?.tpopContentMulti:this.authoringContentData?.tpopContent;
    this.tpopContentSuccessNote1 = this.authoringContentData?.tpopContentMultiSuccessNote1;
    this.tpopContentSuccessNote2 = this.authoringContentData?.tpopContentMultiSuccessNote2;
    this.tpopContentMultiSuccessGen1 = this.authoringContentData?.tpopContentMultiSuccessGen1; 
    this.tpopContentMultiSuccessGen2 = this.authoringContentData?.tpopContentMultiSuccessGen2; 

    if(this.selectedActivity){
      this.popupTitle = this.authoringContentData?.cancellationTitile;
      this.popupMessage = this.authoringContentData?.cancellationContent;  
    }
    this.ngbModalOptions = {
      backdrop: "static",
      keyboard: false,
      container: "#am-container-custom",
    };
    this.countSelectedArray();
    if(this.GEN_POP?.transactionAction === "bulkTpop"){
      this.transactionRef = this.GEN_POP?.tpopGenerationTransRefNumber;
      this.transactionAction = this.GEN_POP?.transactionAction;
      this.isMultiline = true;
      this.pinSuccess();
    }
  }
  goToManageLines(){
    this.manageLineService.close();
    let clickFlow = 1;
    this.router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_MANAGE_LINES], { queryParams: { flow: clickFlow } });
  }
  goToTransactionDetail(accountOrderId){
    this.manageLineService.close();
    this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.ACCOUNT_ORDER_ID, accountOrderId);
    this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.IS_TRANSFER_NUMBER, false);
    this.router.navigate([
      TRANSACTION_HISTORY_CONSTANTS.REDIRECT_TO_HISTORY_DETAILS_PAGE,
    ]);
  }

  closePopup(){
    this.manageLineService.close()
    this.closeInfo.emit(true);
  }
  countSelectedArray(){  
    const selectedVlue =    this.selectedLines.filter((node)=>{
           return  node.isSelected
    })
    this.activeLine = selectedVlue.length ;

  }
  setPortPinStatus(){
    const lines:any = [];
    const reqLine = [];
    let currentOrg = this._helperUtilSvc.getOrgID();
    const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    for(const line of this.selectedLines){
      if(line?.portOutPin){
        line.portOutPinStatus = this.authoringContentData?.portOutPinStatus;
      }else{
        line.portOutPinStatus = '-';
      }
      lines.push(line);
      !line.isSelected || reqLine.push(
        {
          "orgId":   currentOrg,
          "logonId": authInfo?.logonEmail || COMMON_CONSTANTS.LOGON_ID,
          "email": authInfo?.logonEmail || COMMON_CONSTANTS.LOGON_ID,          
          "msisdn": line.msisdn,
          "ban": line.ban        
      }) 
    }
    this.selectedLines = lines;   
    this.reqLIne = reqLine
  }


  lineRestrictions(simDeviceLock, portOutBlock, simProtection, portOutPin){
    let rstLst = [];
    if(portOutBlock === true){
      rstLst.push(MANAGE_LINE_CONST.PORT_OUT_PROTECTION_ON_STS_TXT);
    } 
    if(simDeviceLock === true){
      rstLst.push(MANAGE_LINE_CONST.LOCK_SIM_TO_DEVICE_STS_TXT);
    }
    if(simProtection === true){
      rstLst.push(MANAGE_LINE_CONST.SIM_PROTECTION_ON_STS_TXT);
    }
    if(portOutPin === true){
      rstLst.push(MANAGE_LINE_CONST.POP_CTA_TXT);
    }
    return rstLst;
  }

  

  genPortOutPin() {  
  if (this.isMultiline){
    this.setPortPinStatus();
     const reqObj = 
          {
            "targetServiceName": "tpop-generation",
            "ban": this.GEN_POP.ban,
            "requests": this.reqLIne
          }          
    this.manageLineService.bulkServiceRestore(reqObj).subscribe({
      next: (res) =>  { 
        this.pinResponse(res);
      },
      error: (err) => {
            this.utilsSvc.errorHandling(err);
         }
      })
 }
  else{
    this.manageLineService.genratePortOutPin(this.GEN_POP).subscribe({
      next: (res) =>  { 
        this.pinResponse(res);
      },
      error: (err) => {
            this.utilsSvc.errorHandling(err);
         }
      })
  }

  }

  pinResponse(res : any){
    if (res?.status?.toUpperCase() ==  MANAGE_LINE_CONST.SUCCESS) {
      this.resData = res;
      this.pinSuccess()    
    }else{
      this.pinError();
    }
  }
  pinSuccess(){
    if(this.isMultiline){
      this.portOutPin = 1; 
      this.popupTitle = this.authoringContentData?.tpopTitleMultiSuccess;
      this.popupMessage = this.authoringContentData?.tpopContentMultiSuccess;
      this.tpopContentSuccessNote1 = this.authoringContentData?.tpopContentMultiSuccessNote1;
      this.tpopContentSuccessNote2 = this.authoringContentData?.tpopContentMultiSuccessNote2;
    }else{
      this.portOutPin = 1;
      this.popupTitle = this.authoringContentData?.tpopTitleSuccess;
      this.popupMessage = this.authoringContentData?.tpopContentSuccess;
    }
  }
  
  pinError(){
    this.portOutPin = 2; 
    this.popupTitle = this.authoringContentData?.tpopTitleError;
    this.popupMessage = this.authoringContentData?.tpopContentError;
  }
  
  updateSelection(event, line) {
    if (event.checked) {
      line.isSelected = true;
    } else{
      line.isSelected= false;
    }
    this.countSelectedArray()
  }
  tPopCancellation(){
    this.manageLineService.portOutPinCancellation(this.GEN_POP).subscribe({
      next: (res) =>  { 
        if (res?.status?.toUpperCase() ==  MANAGE_LINE_CONST.SUCCESS) {
          this.resData = res;
          this.portOutPin = 1; 
          this.tpcStatus = true
          this.popupTitle = this.authoringContentData?.cancellationTitileSuccess;
          this.popupMessage = this.authoringContentData?.cancellationContentSuccess;
        }else{
          this.pinError();
        }
      },
      error: (err) => {              
        this.utilsSvc.errorHandling(err);
        this.closeInfo.emit(true);
         }
      })
  }
  checkControlMessage(line){
    if(line.portOutPin){
      return MANAGE_LINE_CONST.POP_CTA_GENERATED_TXT;
    }else{
      return "--";
    }
  }
}
 